module.exports = __webpack_public_path__ + "static/media/sell_take_order_teach_4.bbd28b06.jpg";